const eventsData = [
  {
    id: 1,
    title: "Books Distribution",
    description:
      "Educational books were distributed to students to promote reading habits and support academic growth.",
    image: "/images/events/booksdistribution/1.jpg",
    Date: "2021-08-12",
  },
  {
    id: 2,
    title: "Clothes Distribution",
    description:
      "Essential clothing items were distributed to the needy, aiming to provide dignity and comfort.",
    image: "/images/events/clothesdistribution/1.jpg",
    Date: "2022-01-25",
  },
  {
    id: 3,
    title: "Freedom Fighters Books Distribution",
    description:
      "Books highlighting the contributions of freedom fighters were distributed to inspire young minds.",
    image: "/images/events/freedomfighterbooks/1.jpg",
    Date: "2020-11-15",
  },
  {
    id: 4,
    title: "Kalinali",
    description:
      "A vibrant cultural program that showcased local folk traditions, music, and dance performances.",
    image: "/images/events/kalinali/1.jpg",
    Date: "2023-02-09",
  },
  {
    id: 5,
    title: "Kargil Vijaya Mahotsava",
    description:
      "A tribute to the bravery of Kargil war heroes through patriotic events and student participation.",
    image: "/images/events/kargil/1.jpg",
    Date: "2019-07-26",
  },
  {
    id: 6,
    title: "Vanavasi Seva",
    description:
      "An outreach initiative to serve tribal communities with health checkups, education kits, and support.",
    image: "/images/events/vanavasiseva/1.jpg",
    Date: "2021-12-05",
  },
  {
    id: 7,
    title: "Temple Cleaning",
    description:
      "Volunteers gathered to clean and maintain temple surroundings as a form of community service.",
    image: "/images/events/templecleaning/1.jpg",
    Date: "2020-06-18",
  },
  {
    id: 8,
    title: "Notebook Distribution",
    description:
      "Distribution of notebooks to school children to support their learning and reduce school dropouts.",
    image: "/images/events/notebookdistribution/1.jpg",
    Date: "2022-06-15",
  },
  {
    id: 9,
    title: "Abhimani Balaga",
    description:
      "A motivational gathering for youth featuring yoga sessions, life lessons, and cultural expressions.",
    image: "/images/events/abhimani/1.jpg",
    Date: "2021-10-10",
  },
  {
    id: 10,
    title: "Achievers Introduction",
    description:
      "An event to recognize and introduce local achievers and role models to inspire the community.",
    image: "/images/events/achieversintro/1.jpg",
    Date: "2023-03-21",
  },
  {
    id: 11,
    title: "Chinnara Chittara",
    description:
      "An arts and crafts celebration where children creatively expressed themselves through drawings and performances.",
    image: "/images/events/chinnarachittara/1.jpg",
    Date: "2024-01-08",
  },
  {
    id: 12,
    title: "Annual Cultural Fest - Desham",
    description:
      "A celebration of India's heritage through plays, patriotic songs, and traditional performances.",
    image: "/images/events/desham/1.jpg",
    Date: "2023-08-14",
  },
  {
    id: 13,
    title: "Dr. Vijaya’s Address",
    description:
      "A thought-provoking session by Dr. Vijaya addressing students on career, values, and social awareness.",
    image: "/images/events/drvijaya/1.jpg",
    Date: "2019-11-27",
  },
  {
    id: 14,
    title: "Education Awareness Program",
    description:
      "Interactive sessions to stress the importance of education and guide youth on career opportunities.",
    image: "/images/events/educate/1.jpg",
    Date: "2020-03-09",
  },
  {
    id: 15,
    title: "Girl Child Day",
    description:
      "A special program to uplift and empower girls through awareness talks and cultural presentations.",
    image: "/images/events/girlchildday/1.jpg",
    Date: "2021-10-11",
  },
  {
    id: 16,
    title: "Guru Poornima Celebration",
    description:
      "A reverent occasion where students honored teachers and mentors through devotional events.",
    image: "/images/events/gurupoornima/1.jpg",
    Date: "2024-07-21",
  },
  {
    id: 17,
    title: "Sister Niveditha Jayanti",
    description:
      "An observance of Sister Niveditha’s life, focusing on her service in education and women empowerment.",
    image: "/images/events/niveditha/1.jpg",
    Date: "2023-10-28",
  },
  {
    id: 18,
    title: "Public Awareness Campaign",
    description:
      "Awareness drives were conducted on topics such as cleanliness, health, safety, and environmental care.",
    image: "/images/events/public/1.jpg",
    Date: "2022-09-17",
  },
  {
    id: 19,
    title: "Sanskrit Classes",
    description:
      "Language development workshops aimed at reviving and promoting interest in Sanskrit literature and speech.",
    image: "/images/events/sanskritclass/1.jpg",
    Date: "2024-04-13",
  },
  {
    id: 20,
    title: "School Visit",
    description:
      "Interactive school visits involving educational games, motivational talks, and contributions of learning materials.",
    image: "/images/events/school/1.jpg",
    Date: "2020-01-20",
  },
  {
    id: 21,
    title: "Sharada Pooja",
    description:
      "A devotional event to seek blessings of Goddess Sharada for knowledge, wisdom, and academic excellence.",
    image: "/images/events/sharadapooja/1.jpg",
    Date: "2019-10-05",
  },
];

export default eventsData;
